module.exports = __webpack_public_path__ + "static/3-92a5e49ebb5b5c2478f8291f03ba59fe.png";